import { render, staticRenderFns } from "./AttachmentEventHandler.vue?vue&type=template&id=5eb2b56a"
import script from "./AttachmentEventHandler.vue?vue&type=script&lang=js"
export * from "./AttachmentEventHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports